import { render, staticRenderFns } from "./NTimesUsage.html?vue&type=template&id=b60f9c36&"
import script from "./NTimesUsage.js?vue&type=script&lang=js&"
export * from "./NTimesUsage.js?vue&type=script&lang=js&"
import style0 from "./NTimesUsage.css?vue&type=style&index=0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports